<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
        <el-form :model="table.where"  class="ele-form-search d-flexspabet"
               @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
          <el-form-item>
            <el-button @click="showEdit=true"   class="ele-btn-icon addbtn "  v-if="permission.includes('sys:headline:add')">添加头条</el-button>
          </el-form-item>
          <div class="d-flex">
            <el-form-item label="类型:" class="w-170" label-width="77px">
              <el-select v-model="table.where.class" placeholder="请选择" clearable class="ele-fluid">
                <el-option label="政务" value="1"/>
                <el-option label="生活" value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="省:" label-width="35px" class="w-170">
              <el-select v-model="table.where.pid"  @change="handleChangeProv(table.where.pid)" placeholder='请选择省' clearable>
                <el-option v-for="option in provArr" :value="option.pid" :key="option.pid" :label="option.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市:" label-width="35px" class="w-150">
              <el-select v-model="table.where.cid"  @change="handleChangeCity(table.where.cid)" placeholder='请选择市' clearable>
                <el-option v-for="option in cityArr" :value="option.cid" :key="option.cid" :label="option.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="县/区:" label-width="62px" class="w-200">
              <el-select v-model="table.where.aid" placeholder='请选择县/区' @change="$forceUpdate()" clearable>
                <el-option v-for="option in districtArr " :value="option.aid" :key="option.aid" :label="option.name"></el-option>
              </el-select>
            </el-form-item>
            <div class="ml-20">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">搜索
              </el-button>
              <el-button @click="(table.where={category_id: 2})&&$refs.table.reload()">重置</el-button>
            </div>
          </div> 
        </el-form>
				
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" fit  stripe show-header>
        <template slot-scope="{index}">
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" show-overflow-tooltip/>
          <el-table-column label="类型"  show-overflow-tooltip min-width="50px">
						<template slot-scope="scope">
							<span>{{scope.row.class==1?'政务':scope.row.class==2?'生活':''}}</span>
						</template>
					</el-table-column>
          <el-table-column prop="name" label="标题"  show-overflow-tooltip  min-width="240px"/>
          <el-table-column prop="set_area" label="地区"  show-overflow-tooltip  min-width="150px"/>
          <el-table-column prop="like_num" label="点赞量(个)"  show-overflow-tooltip  min-width="100px"/>
          <el-table-column prop="comment" label="评论量(个)"  show-overflow-tooltip  min-width="100px"/>
          <el-table-column prop="look" label="浏览量(次)"  show-overflow-tooltip  min-width="100px"/>
          <el-table-column label="日期" prop="caretetime" show-overflow-tooltip min-width="150px">
            <template slot-scope="{row}">{{ row.caretetime*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="200px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
             <el-link @click="look(row)" icon="el-icon-view" type="primary" :underline="false" v-if="permission.includes('sys:countycircle:edit')">查看</el-link>
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:headline:edit')">编辑</el-link>
              <el-link @click="remove(row)" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:headline:delete')">删除</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->

    <el-dialog v-dialogDrag :title="editForm.id?'消息内容':'添加头条'" :visible.sync="showEdit"
               @closed="editForm={}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-card shadow="never">
          <el-form-item label="消息标题：" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入标题" clearable :disabled='editForm.id?true:false'/>
          </el-form-item>
          <el-form-item label="类型：" prop="class">
            <el-select v-model="editForm.class" :disabled='editForm.id?true:false'>
							<el-option v-for="item in typeList" :key="item.type" :label="item.name" :value="item.type"/>
            </el-select>
          </el-form-item>
					<div>
						<el-form-item label="所属区域：" v-if="!editForm.id" prop="pid">
							<el-select v-model="editForm.pid"  @change="handleChangeProv1(editForm.pid)" class="selectStyle2 mr-10 " clearable placeholder="请选择省">
								<el-option v-for="option in provArr" :value="option.pid" :key="option.pid" :label="option.name"></el-option>
							</el-select>
							<el-select v-model="editForm.cid"  @change="handleChangeCity1(editForm.cid)" class="selectStyle2 mr-10 " clearable placeholder="请选择市">
								<el-option v-for="option in cityArr" :value="option.cid" :key="option.cid" :label="option.name"></el-option>
							</el-select>
							<el-select v-model="editForm.aid"  @change="$forceUpdate()" class="selectStyle2 mr-10 " clearable placeholder="请选择区/县">
								<el-option v-for="option in districtArr " :value="option.aid" :key="option.aid" :label="option.name"></el-option>
							</el-select>
						</el-form-item>
					</div>
          <div style="width=100%;height: 10px;"></div>
          <el-form-item label="封面图：" prop="images"  show-overflow-tooltip  v-if="editForm.id">
            <el-input v-model="editForm.images" controls-position="right" :min="0" placeholder="" class="ele-fluid ele-text-left" disabled/>
            <el-image style="width: 100px; height: 100px" class="mt-10" :src="editForm.images"  fit="cover" :preview-src-list="[editForm.images]"></el-image>
          </el-form-item>
          <el-form-item label="封面图：" prop="images"  show-overflow-tooltip  v-else>
            <uploadImage :limit="1" v-model="editForm.images"></uploadImage>
          </el-form-item>
         
          <el-form-item label="发布内容：" prop="content" :disabled='editForm.id?true:false'>
            <tinymce-editor v-model="editForm.content" @init="editContent" />
          </el-form-item>
        </el-card>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 查看线圈弹窗 -->
        <el-dialog v-dialogDrag title="查看头条" :visible.sync="showEdit2"
                   @closed="editForm2={}" :destroy-on-close="true" :lock-scroll="false">
          <el-form :model="editForm2" ref="editForm2" label-width="100px">
            <el-card shadow="never">
              <el-form-item label="标题：" prop="name">
                <el-input type="textarea" :rows="1" placeholder="请输入内容" v-model="editForm2.name" disabled> </el-input>
              </el-form-item>
              <el-form-item  label="显示图片：" prop="images"  show-overflow-tooltip >
                <div v-for="(option, index) in editForm2.imgList" :key="index" style="width:100px;height:100px;margin-right:10px;float:left;margin-bottom:10px">
                  <el-image v-if="option.type==1"  style="width: 100px; height: 100px;float: left" class="mt-10 mr-10" :src="option.src" fit="cover" :preview-src-list="[editForm2.imgArr]"></el-image>
                  <video v-if="option.type==2"  style="width: 100px; height: 100px;float: left"  :src="option.src"  controls="controls">您的浏览器不支持视频播放</video>
                </div>
              </el-form-item>
            </el-card>
            <el-card shadow="never">
              <el-form-item style="display: flex;flex-direction: column;">
                <div v-if="editForm2.like_num!=0"><img style="width: 20px; vertical-align: sub; margin-right: 10px;" src="../../../assets/zan.png" alt="">{{editForm2.like_num}}人</div>
    					<div style="border-bottom: dashed 1px #000000;font-size: 16px;font-weight: bold;">评论详情</div>
                <div>
    							<!-- 评论 -->
    							<div v-for="(option, index) in editForm2.comment_list" :key="index" class="commentBox">
    								<div class="commentListBox">
                      
                      <div style="float: right; margin-top: 10px;" class="ele-action">
                        <el-link slot="reference" icon="el-icon-delete" type="danger" @click="removeSelf(option)" :underline="false">删除</el-link>
                      </div>
                      <div class="commentList">
    										<div class="commentHeading">
    											<img class="imgSize" :src="option.user_info.headimg" />
    										</div>
    										<div class="commentDetail">
    											<div>
    												<span class="commentName">{{option.user_info.name}}</span>
    												<span class="contentTime">{{option.createtime*1000 | toDateString}}</span>
    											</div>
    											<div class="commentContent">评论内容：{{option.content}}</div>
    											<div v-for="(option1, index) in option.comment_list" :key="index" class="replyList">
    												<div class="commentHeading1">
    													<img class="imgSize" :src="option1.user_info.headimg" />
    												</div>
    												<div class="commentDetail">
    													<div>
    														<span class="commentName">{{option1.user_info.name}}</span>
    														<span class="contentTime">{{option1.createtime*1000 | toDateString}}</span>
    													</div>
    													<div class="commentContent">回复内容：{{option1.content}}</div>
    												</div>
    											</div>
    										</div>
    									</div>
    								</div>
    							</div>
    						</div>
    						<div v-if="editForm2.comment_list==''" style="height: 50px;padding-top: 20px;">暂无评论</div>
              </el-form-item>
            </el-card>
          </el-form>
        </el-dialog>
    
    
    
    
    
    、
  </div>
</template>

<script>
import TinymceEditor from '@/components/TinymceEditor'
import { mapGetters } from "vuex";
import uploadImage from '@/components/uploadImage';
export default {
  name: "SysHeadline",
  components: {TinymceEditor,uploadImage},
  data() {
    return {
      table: {url: '/countycircle/index', where: {category_id:2}},  // 表格配置
      provArr:[],
      cityArr:[],
      districtArr:[],
      choose: [],  // 表格选中数据
      showEdit: false,  // 是否显示表单弹窗
      showEdit2:false, //是否显示评论
      editForm: {},  // 表单数据
      editForm2:{},
			typeList:[
				{
					type:1,
					name:"政务"
				},{
					type:2,
					name:"生活"
				}
			],
      editRules: {  // 表单验证规则
				class: [{
					required: true,
					message: '请选择类型',
					trigger: "change"
				}],
				name: [{
					required: true,
					message: '请输入消息标题',
					trigger: "blur"
				}],
				pid: [{
					required: true,
					message: '请选择所属区域',
					trigger: 'change'
				}],
				images: [{
					required: true,
					message: '请选择封面图',
					trigger: 'change'
				}],
      },
    }
  },

  created(){
    this.$http.get('/common/province_list').then(res=>{
      let data=JSON.parse(res.data)
      this.provArr=data
    })





  },
computed: {
    ...mapGetters(["permission"]),
},
  mounted() {
  },
  methods: {
    editContent() {
      return {
        menubar: false,
        // file_picker_callback: this.file_picker_callback,
        skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' : '/tinymce/skins/ui/oxide',
        content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',

      };

    },
    /**
     * 显示编辑
     */
    edit(row) {
      this.$http.get('/headline/info?id=' + row.id).then(res => {
        if (res.data.code === 0) {
          // this.showEdit = true;
          this.editForm = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
			const loading = this.$loading({ lock: true });
			if(this.editForm){
				this.showEdit = true;
				loading.close();
			}
    },
    look(row){
      let that=this;
      this.$http.get('/countycircle/info?id=' + row.id).then(res => {
        if (res.data.code === 0) {
          res.data.data.imgArr=res.data.data.images.split(',')
          res.data.data.imgList=[]
          res.data.data.imgArr.forEach(function(item){
            let obj={id:'',src:''}
                   obj.type=that.$util.getFileType(item);
                    obj.src=item
            //console.log(obj)
            res.data.data.imgList.push(obj)
            //console.log(res.data.data.imgList)
          })
          this.showEdit2 = true;
          this.editForm2=res.data.data
          //console.log('edit7777777777777777777',this.editForm2)
      
      
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
      
    },
    /**
     * 保存编辑
     */
    save() {
      //console.log(this.editForm)
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.editForm.category_id=2;
          this.editForm.type=1;
          this.$http.post('/headline/edit', this.editForm).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
              this.showEdit = false;
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 刪除(批量刪除)
     */
    remove(row) {
      this.$confirm('确定要删除选中的头条记录吗?', '提示', {type: 'warning'}).then(() => {
        const loading = this.$loading({lock: true});
        this.$http.post('/headline/headline_del', {id: row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      })
    },
    /**
     *选择省
     **/
    handleChangeProv(e){
      /** 获取被选省份的pid**/
      let pid=''
      this.provArr.forEach(function(item){
        if(item.pid==e){
          pid=item.pid
        }
      })
      /** 根据被选省份的pid获取省市下面的市**/
      this.$http.post('/common/city_list',{pid:pid}).then(res=>{
        let data=JSON.parse(res.data)
        this.cityArr=data
        /** 选择省份清空市县**/
        this.table.where.cid=''
        this.table.where.aid=''
      })
    },
    /**
     *选择市
     **/
    handleChangeCity(e){
			if(e){
      /** 获取被选市的cid**/
      let cid=''
      this.cityArr.forEach(function(item){
        if(item.cid==e){
          cid=item.cid
        }
      })
      /** 根据被选市的cid获取市下面的县**/
      this.$http.post('/common/area_list',{cid:cid}).then(res=>{
        let data=JSON.parse(res.data)
        this.districtArr=data
        /** 选择省份清空县**/
        this.table.where.aid=''
      })
			}else{
				this.table.where.pid = ''
				this.table.where.aid = ''
			}
    },
    /**
     *选择省
     **/
    handleChangeProv1(e){
      /** 获取被选省份的pid**/
      let pid=''
      this.provArr.forEach(function(item){
        if(item.pid==e){
          pid=item.pid
        }
      })
      /** 根据被选省份的pid获取省市下面的市**/
      this.$http.post('/common/city_list',{pid:pid}).then(res=>{
        let data=JSON.parse(res.data)
        this.cityArr=data
        /** 选择省份清空市县**/
        this.editForm.cid=''
        this.editForm.aid=''
      })
    },
    /**
     *选择市
     **/
    handleChangeCity1(e){
			if(e){
      /** 获取被选市的cid**/
      let cid=''
      this.cityArr.forEach(function(item){
        if(item.cid==e){
          cid=item.cid
        }
      })
      /** 根据被选市的cid获取市下面的县**/
      this.$http.post('/common/area_list',{cid:cid}).then(res=>{
        let data=JSON.parse(res.data)
        this.districtArr=data
        /** 选择省份清空县**/
        this.editForm.aid=''
      })
			}else{
				this.editForm.pid = ''
				this.editForm.aid = ''
			}
    },
    removeSelf(opt){
      //console.log('--------removeSelf----------',opt);
      let lookRow={};
      lookRow.id=opt.county_circle_id;
     
      this.$confirm('确定要删除此评论吗?', '提示', {type: 'warning'}).then(() => {
        const loading = this.$loading({lock: true});
        this.$http.post('/Countycircle/delCountyCirceleComment', {id: opt.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.look(lookRow);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      })
      
    },




 }
}
</script>

<style scoped>
.ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
  width: 100%;
}
/deep/.el-dialog{
	margin-top: 30px !important;
}
/* 评论 */
.commentBox{
	padding: 15px 15px 0 15px;
}
.commentBox img{
	border-radius: 50%;
	width: 100%;
	height: 100%;
}
.commentTotal{
	font-size: 16px;
	color: #333;
}
.commentList{
	display: flex;
	padding: 10px 0;
	border-bottom: 1px solid #eee;
}
.commentDetail{
	margin-left: 15px;
}
.replyList{
	display: flex;
	margin-top: 10px;
}
.commentHeading{
	height: 32px;
	width: 32px;
}
.commentHeading1{
	height: 20px;
	width: 20px;
}
.commentName{
	font-size: 13px;
	color: #333;
	display: inline-block;
	margin-right: 10px;
}
.contentTime{
	color: #999;
}
.commentContent{
	font-size: 14px;
	color: #333;
	margin: 8px 0;
}
.selectStyle2 {
	width: 137px;
	height: 27px;
}
	.tox-tinymce-aux {
	    z-index: 3000 !important;
	}
</style>
       